import ContractFormSettings from './ContractFormSettings';

export default ContractFormSettings;
